import { render, staticRenderFns } from "./OrderPriceTable.vue?vue&type=template&id=ca993eea&scoped=true"
import script from "./OrderPriceTable.vue?vue&type=script&lang=js"
export * from "./OrderPriceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca993eea",
  null
  
)

export default component.exports